import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl text-sm font-semibold transition-all duration-150 active:scale-[.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1E9E2A]/40 focus-visible:ring-offset-1 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground shadow-[0_6px_16px_-8px_rgba(26,35,64,.55)] hover:-translate-y-px hover:shadow-[0_10px_22px_-10px_rgba(26,35,64,.6)] hover:brightness-110",
        destructive:
          "bg-destructive text-destructive-foreground shadow-[0_6px_16px_-8px_rgba(220,38,38,.5)] hover:-translate-y-px hover:bg-destructive/90",
        outline:
          "border border-slate-200 bg-white shadow-[0_1px_2px_rgba(16,24,40,.05)] hover:border-slate-300 hover:bg-slate-50 hover:text-accent-foreground",
        secondary:
          "bg-secondary text-secondary-foreground shadow-[0_6px_16px_-8px_rgba(30,158,42,.55)] hover:-translate-y-px hover:brightness-105",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-8 rounded-lg px-3 text-xs",
        lg: "h-11 rounded-xl px-8",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
